import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useSectionStyles = makeStyles({
  section: {
    display: "flex",
    flexDirection: "column",
  },
  cardsRow: {
    display: "flex",
    gap: designTokens.spacing[4],
    flexWrap: "wrap",
  },
});
